export default "__VITE_ASSET__CkL31yJi__"